import { memo } from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@ridemaadi/utils';
import { Logo } from '../Logo';
import { useAuth } from '../../providers/AuthProvider';
import { APP_HEADER_HEIGHT_PX } from './shellLayout';
import { useSmartHeader } from './header/SmartHeaderProvider';
import { HeaderNotificationBell } from './HeaderNotificationBell';

function greetingName(displayName: string | null | undefined): string {
  const trimmed = displayName?.trim();
  if (!trimmed) return 'Rider';
  return trimmed.split(/\s+/)[0] ?? 'Rider';
}

/** Global fixed app header - logo left, profile center, alerts right. */
export const AppHeader = memo(function AppHeader() {
  const { user } = useAuth();
  const { scrolled } = useSmartHeader();
  const name = greetingName(user?.displayName);

  return (
    <header
      className={cn(
        'shrink-0 bg-surface transition-shadow duration-200',
        scrolled ? 'border-b border-border/80 shadow-sm' : 'border-b-2 border-primary shadow-none',
      )}
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
      role="banner"
    >
      <div className="mx-auto max-w-app px-4">
        <div
          className="grid grid-cols-[1fr_auto_1fr] items-center gap-2"
          style={{ height: APP_HEADER_HEIGHT_PX }}
        >
          <Link to="/dashboard" className="justify-self-start shrink-0" aria-label="RideMaadi home">
            <Logo variant="header" className="h-[36px] sm:h-[40px] max-w-[min(140px,34vw)] sm:max-w-[min(180px,38vw)]" />
          </Link>

          {user ? (
            <Link
              to="/profile"
              className="max-w-[min(180px,42vw)] truncate text-center text-xs font-medium text-content hover:text-primary sm:text-sm"
              aria-label={`Profile for ${name}`}
            >
              Hi, {name} 👋
            </Link>
          ) : (
            <span className="text-center text-xs text-muted sm:text-sm" aria-hidden />
          )}

          <div className="flex justify-end">
            {user ? <HeaderNotificationBell /> : null}
          </div>
        </div>
      </div>
    </header>
  );
});
